import CrudApi from '@crudApi';

const API = {
  add: function (data) {
    return CrudApi({ maxRateLimit: 3, saveSnapshot: false}).post('/api/auth/register', data);
  },
  forgetPassword: function (email) {
    return CrudApi({ maxRateLimit: 3, useChunk: false, useFormData: false, saveSnapshot: false }).post('/api/auth/forget-password', email);
  },
  resetPassword: function ({ values }) {
    return CrudApi({ maxRateLimit: 3, useChunk: false, useFormData: false, saveSnapshot: false }).post('/api/auth/reset-password', values)
  },
  verifyAccount: function (token) {
    return CrudApi({ maxRateLimit: 3, useChunk: false, useFormData: false, saveSnapshot: false }).post('/api/auth/verify-email', { token });
  },
  getPasswordPolicy: function () {
    return CrudApi().get('/api/system-configs/additional-configs/regex');
  }
};

export default API;
